import Choices from 'choices.js';

export const bannerRooms = () => {

	let bannerRoomModules = document.querySelectorAll('.m__banner-rooms');
	if(bannerRoomModules){
		bannerRoomModules.forEach((module) => {

			let bannerRoomFilterEl = module.querySelector('.js__banner-rooms-switcher');

			//Init nice styled dropdown
			const choicesConfig = {
				itemSelectText: '',
				shouldSort: false,
				searchEnabled: false,
			},
			bannerRoomsFilter = new Choices(bannerRoomFilterEl,choicesConfig);


			if(window.innerWidth < 992){
				bannerRoomsFilter.setChoices(
				  [
				    { value: '', label: 'Switch Room Type', disabled: true, selected: true },
				  ]
				);
				//bannerRoomsFilter.setChoiceByValue(0);
			}

			bannerRoomFilterEl.addEventListener("change", (event) => {
				event.preventDefault();
				window.location.href = bannerRoomFilterEl.value;
			});

		})
	}

	

}